import i18n from '@/lang'
import { zhThemeColor, enThemeColor } from '@/styles/variables.scss'

/*
 * 对象重置
 * @param object object  要重置的对象
 * @param object defaultValues 默认值对象
 * @return void
 */
export function resetObject ( object, defaultValues ) {
  for(let index in object) {
    if(typeof object[index] === 'object') { 
      resetObject( object[index] )
    }
    else {
      //如果有传默认值，默认值中存在该属性，并且该属性值非对象
      if(typeof defaultValues !== 'undefined' && typeof defaultValues[index] !== 'undefined' && typeof defaultValues[index] !== 'object') {
        object[index] = defaultValues[index]
      }
      else {
        object[index] = ''
      }
    }
  }
}

/*
 * 可以保留两位小数的字段校验是否为0，为0时，给出错误提示。作为async validator的校验规则rules
 * @param string fieldName 字段名称
 * @return function
 */
export function validatorZero(fieldName) {
  fieldName = fieldName || ''
  return function validator(rule, value, callback, source, option) {
      var errors = []
      if(parseInt(value*100) === 0) {
        errors.push( new Error( i18n.t('error.cannotBeZero', {field: fieldName}) ) )
      }
      return errors
    }
}

/*
 * 乘法函数，用来得到精确的乘法结果
 * 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 * @param number arg1 
 * @param number arg2
 * @return number
 */
export function accMul(arg1, arg2) {
  let m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString(),
      num1, num2
  try {
    if(!/e/.test(s1)) {
      m += s1.split(".")[1].length
    }
  }
  catch(e) {
  }
  try {
    if(!/e/.test(s2)) {
      m += s2.split(".")[1].length
    }
  }
  catch(e) {
  }

  num1 = /e/.test(s1) ? Number(s1) : Number(s1.replace('.', ''))
  num2 = /e/.test(s2) ? Number(s2) : Number(s2.replace('.', ''))
  return num1 * num2 / Math.pow(10, m)
}

/* 
 * 除法函数，用来得到精确的除法结果
 * 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
 * @param number arg1 
 * @param number arg2
 * @return number
 */
export function accDiv(arg1, arg2) {
  let t1 = 0, t2 = 0, 
      s1 = arg1.toString(),
      s2 = arg2.toString(),
      num1, num2
  try {
    if(!/e/.test(s1)) {
      t1 = s1.split(".")[1].length //获取小数位数
    }
  }
  catch (e) {
  }
  try {
    if(!/e/.test(s2)) {
      t2 = s2.split(".")[1].length
    }
  }
  catch (e) {
  }

  num1 = /e/.test(s1) ? Number(s1) : Number(s1.replace(".", "")) //转换成整数
  num2 = /e/.test(s2) ? Number(s2) : Number(s2.replace(".", ""))
  return (num1 / num2) * Math.pow(10, t2 - t1)
}

/*
 * 从hash上获取目标参数
 * @param {string} target  目标参数
 * @return {string} data  返回目标参数的值
 */
export function getTargetFromHash(target) {
  let param = ''
  if (location.hash) {
    // 获取问号出现的位置
    const index = location.hash.indexOf('?')
    // 获取问号后所有的参数字符串
    const allParam =  location.hash.substring(index + 1)
    // 以&分割后的数组
    const attrs = allParam.split('&')
    // 过滤目标参数
    const params = attrs.filter(item => item.split('=')[0] === target )
    // 获取目标参数的值
    const targetArr = params.length > 0 ? params[0].split('=') : []
    param = targetArr[1] ? targetArr[1] : ""
  }
  return param
}

/*
 * 检验色值是否有效
 * @param {number}   themeColor 颜色色值的数字
 * @return {boolean}  true 符合检验规则，false不符合检验规则
 */
export function checkThemeColor(themeColor) {
  // 正则匹配颜色色值,支持简写的颜色色值
  const regColor = /^([A-F\d]{6}|[A-F\d]{3})$/i
  const match = themeColor.match(regColor)
  return match ? true : false
}

/*
 * 设置主题色
 * @return void
 */
export function setThemeColor() {
  // 获取主题颜色
  const colorNumber = getTargetFromHash('themeColor')
  // 获取默认主题颜色
  let defaultThemeColor = process.env.LANG === 'zh' ? zhThemeColor : enThemeColor
  const themeColor = checkThemeColor(colorNumber) ? `#${colorNumber}` : defaultThemeColor
  // 在root上添加新的属性，用于设置主题色
  const root = document.documentElement
  root.style.setProperty('--theme-color', themeColor)
}


// WEBPACK FOOTER //
// ./src/utils/index.js